import { db, collection, getDocs, query, where } from './FirebaseService';

const nameToOdooMapping = {
  'ginecología': 15, 'ginecologia': 15,
  'psicología': 16, 'psicologia': 16,
  'nutrición': 17, 'nutricion': 17,
  'salud general': 18, 'skincare': 18,
  'entrenamiento': 28,
};

const emojiMap = {
  'ginecología': '🌸', 'ginecologia': '🌸',
  'psicología': '💭', 'psicologia': '💭',
  'nutrición': '🥗', 'nutricion': '🥗',
  'salud general': '🩺', 'skincare': '✨',
  'entrenamiento': '💪',
};

function getOdooId(specialtyName) {
  const nameLower = specialtyName.toLowerCase();
  if (nameToOdooMapping[nameLower]) return nameToOdooMapping[nameLower];
  for (const [key, value] of Object.entries(nameToOdooMapping)) {
    if (nameLower.includes(key)) return value;
  }
  return 18;
}

function getEmoji(specialtyName) {
  const nameLower = specialtyName.toLowerCase();
  if (emojiMap[nameLower]) return emojiMap[nameLower];
  for (const [key, emoji] of Object.entries(emojiMap)) {
    if (nameLower.includes(key)) return emoji;
  }
  return '💫';
}

const specialtyService = {
  async getFormattedOnDemandSpecialties() {
    try {
      const q = query(collection(db, 'dais_specialty'), where('active', '==', true));
      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => {
        const data = doc.data();
        const odooId = getOdooId(data.name || '');
        const includedDurations = data.durations || [];
        const extraDurations = data.extra_durations || [];
        const durationId = includedDurations[0]?.id || extraDurations[0]?.id || 109;
        const extraDurationId = extraDurations[0]?.id || null;
        return {
          id: odooId,
          odooId,
          firebaseId: doc.id,
          durationId,
          extraDurationId,
          name: data.name || 'Sin nombre',
          icon: getEmoji(data.name || ''),
          active: data.active || false,
          durations: includedDurations,
          extra_durations: extraDurations,
        };
      });
    } catch (err) {
      console.warn('[specialtyService] Error:', err);
      return [];
    }
  },

  async getSpecialtyConfig() {
    try {
      const specialties = await this.getFormattedOnDemandSpecialties();
      const config = {};
      specialties.forEach(spec => {
        config[spec.odooId] = {
          id: spec.odooId,
          duration: spec.durationId,
          extraDuration: spec.extraDurationId,
          name: spec.name,
          icon: spec.icon,
          firebaseId: spec.firebaseId,
          durations: spec.durations,
          extra_durations: spec.extra_durations,
        };
      });
      return config;
    } catch (err) {
      console.warn('[specialtyService] getSpecialtyConfig error:', err);
      return {};
    }
  },
};

export default specialtyService;
